/**
 * Runtime configuration provided by PHP via wp_localize_script().
 *
 * Importing from this module gives every other file a single, well-typed
 * source of truth and makes the global access easy to mock in tests.
 *
 * `nonce` and `isLogged` are intentionally writable so the login modal can
 * mutate them after a successful sign-in/register without forcing a full
 * page reload (the original nonce was minted while the user was logged out
 * and would no longer authenticate against the user-bound endpoints).
 */

const fallback = {
    ajaxUrl: '/wp-admin/admin-ajax.php',
    nonce: '',
    isLogged: false,
    loginUrl: '',
    registerUrl: '',
    canRegister: true,
    i18n: {},
    limits: {
        maxFileSize: 5 * 1024 * 1024,
        maxFiles: 5,
        allowedMimes: ['image/jpeg', 'image/png', 'image/gif'],
        orderPattern: '^\\d{3}-\\d{7}-\\d{7}$',
    },
};

const provided = typeof window !== 'undefined' && window.marcConfig ? window.marcConfig : {};

export const config = {
    ...fallback,
    ...provided,
    limits: { ...fallback.limits, ...(provided.limits || {}) },
    i18n: { ...fallback.i18n, ...(provided.i18n || {}) },
};

export const updateAuthState = ({ nonce, userId, displayName } = {}) => {
    if (typeof nonce === 'string' && nonce !== '') {
        config.nonce = nonce;
    }
    config.isLogged = true;
    if (typeof userId === 'number') {
        config.userId = userId;
    }
    if (typeof displayName === 'string') {
        config.displayName = displayName;
    }
};

export const t = (key, fallbackText = '') => config.i18n[key] ?? fallbackText ?? key;

export const orderNumberRegex = new RegExp(config.limits.orderPattern);
